export const GhostCard = () => {
  {
    return (
      <div className="mx-auto w-full max-w-screen-lg">
        <div className="animate-pulse rounded-lg bg-white">
          <div className="mb-6  h-8 w-2/4 rounded  bg-light-gray"></div>

          <div className="mb-6 grid grid-cols-3 gap-4">
            <div className="h-4 rounded bg-light-gray"></div>
            <div className="h-4 rounded bg-light-gray"></div>
            <div className="h-4 rounded bg-light-gray"></div>
          </div>
          <div className="mb-6 h-1 rounded  bg-light-gray"></div>

          <div className="mb-6 space-y-4">
            <div className="grid grid-cols-3 gap-4">
              <div className="h-4 rounded bg-light-gray"></div>
              <div className="h-4 rounded bg-light-gray"></div>
              <div className="h-4 rounded bg-light-gray"></div>
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div className="h-4 rounded bg-light-gray"></div>
              <div className="h-4 rounded bg-light-gray"></div>
              <div className="h-4 rounded bg-light-gray"></div>
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div className="h-4 rounded bg-light-gray"></div>
              <div className="h-4 rounded bg-light-gray"></div>
              <div className="h-4 rounded bg-light-gray"></div>
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div className="h-4 rounded bg-light-gray"></div>
              <div className="h-4 rounded bg-light-gray"></div>
              <div className="h-4 rounded bg-light-gray"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};
